import { gql } from "@apollo/client";

export const setVisibilityData = gql`
    mutation setVisibility($lensId: ID!, $visibility: Visibility!) {
        setVisibility(input: { lensId: $lensId, visibility: $visibility }) {
            lens {
                id
                visibility
                status
            }
        }
    }
`;
